module.exports = __webpack_public_path__ + "img/SBBFinal.1ea3e3be.png";